// third-party
import { FormattedMessage } from 'react-intl';

// assets
import InventoryIcon from '@mui/icons-material/Inventory2Outlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import StoreIcon from '@mui/icons-material/Store';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// type

// icons
const icons = { InventoryIcon, ReceiptLongOutlinedIcon, StoreIcon, SwapHorizIcon, ReceiptOutlinedIcon };

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const inventory = {
  id: 'inventory',
  title: <FormattedMessage id="Inventory" />,
  icon: icons.InventoryIcon,
  type: 'group',
  children: [
    {
      id: 'inventory',
      key: 'inventory',
      title: <FormattedMessage id="Inventory" />,
      type: 'item',
      url: '/inventory/inventory-list',
      icon: icons.InventoryIcon,
      breadcrumbs: false,
    },
    {
      id: 'bills',
      key: 'bills',
      title: <FormattedMessage id="Purchase Bills" />,
      type: 'item',
      url: '/inventory/bills',
      icon: icons.ReceiptLongOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'stores',
      key: 'stores',
      title: <FormattedMessage id="Stores" />,
      type: 'item',
      url: '/inventory/stores',
      icon: icons.StoreIcon,
      breadcrumbs: false
    },
    {
      id: 'store-transfers',
      key: 'store-transfers',
      title: <FormattedMessage id="Store Transfers" />,
      type: 'item',
      url: '/inventory/store-transfers',
      icon: icons.SwapHorizIcon,
      breadcrumbs: false
    },
    {
      id: 'sale-bills',
      key: 'sale-bills',
      title: <FormattedMessage id="Sale Bills" />,
      type: 'item',
      url: '/inventory/sale-bills',
      icon: icons.ReceiptOutlinedIcon,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('pharmacy_store_manager') || roles.includes('account_manager') || roles.includes('pharmacy_biller')
    }
  ]
};

export default inventory;
